;(function () {

"use strict";

var EntryView = require('./entry');
var ImageUploadView = require('./image-upload');
var AutocompleteView = require('./autocomplete');
var FileUploadView = require('./file-upload');
var ListInputView = require('./list-input');

var InputView = EntryView.extend({
  initialize: function (opts) {
    EntryView.prototype.initialize.call(this, opts);

    if (this.$el.attr('type') === 'file') {
      if (this.$el.hasClass('image')) {
        this.iuv = new ImageUploadView({ $anchor : this.$el });
      } else {
        this.iuv = new FileUploadView({ el : this.$el });
      }
    }

    if (this.$el.attr('type') === 'list') {
      this.acv = new ListInputView({ $anchor : this.$el });
    }

    if (this.$el.attr('type') === "multiple") {
      this.acv = new AutocompleteView({ $anchor: this.$el });
    }

    if (this.$el.attr('type') === 'text') {
      this.$el.on('keydown', function (e) {
        if( (e.keyCode === 13) ) {
          e.preventDefault();
        }        
      })
    }
  },
  val: function () {
    if (this.iuv) {
      // console.log(this.iuv);
      // console.log(this.iuv.val);
      return this.iuv.val();
    } else if (this.acv) {
      return this.acv.val();
    } else if (this.$el.attr('type') === "radio") {
      if (this.$el.prop('checked')) {
        return EntryView.prototype.val.call(this);
      } else {
        return; 
      }
    } else if (this.$el.attr('type') === "checkbox") {
      if (this.$el.is(':checked')) {
        return 'true';
      } else {
        return 'false';
      }
    } else {
      return EntryView.prototype.val.call(this);
    }
  }
});

module.exports = InputView;

}());